import React from 'react'
import { Backdrop as MUIBackdrop, CircularProgress } from '@mui/material'

type Props = {
  loading: boolean
  close: () => void
}

export function Backdrop ({ loading, close }: Props) {
  return (
    <MUIBackdrop
      sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
      open={loading}
      onClick={close}
    >
      <CircularProgress color="inherit" />
    </MUIBackdrop>
  )
}
